import type { EventsLegFilterProps } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsTabs/EventsTab/EventsLegFilter/index.types';
import { UNATTRIBUTED } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsTabs/EventsTab/index.constants';
import {
  chipClasses,
} from 'Modules/softphone/components/SoftphoneDevTools/styles';
import React from 'react';
import { cn } from '~/lib/utils';

/**
 * EventsLegFilter - Picks which call leg the timeline shows
 *
 * A warm transfer puts two legs on one timeline and a conference puts five;
 * reading them interleaved is what made multi-leg scenarios hard to follow.
 */
export const EventsLegFilter: React.FC<EventsLegFilterProps> = ({
  legs,
  selectedLeg,
  onSelectLeg,
}) => (
  <div
    role="group"
    aria-label="Leg filter"
    className="flex flex-wrap items-center gap-1.5"
  >
    <button
      type="button"
      onClick={() => onSelectLeg(null)}
      className={chipClasses(selectedLeg === null)}
    >
      All legs
    </button>
    {legs.map((leg) => (
      <button
        key={leg}
        type="button"
        onClick={() => onSelectLeg(leg)}
        className={cn(
          chipClasses(selectedLeg === leg),
          'max-w-[140px] font-sp-mono'
        )}
        title={leg}
      >
        <span className="truncate">{leg}</span>
      </button>
    ))}
    <button
      type="button"
      onClick={() => onSelectLeg(UNATTRIBUTED)}
      className={chipClasses(selectedLeg === UNATTRIBUTED)}
      title="Registration and device events, which belong to no call"
    >
      no call
    </button>
  </div>
);
